"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const search_trigger_1 = require("./search-trigger");
const component_text_1 = require("@patternplate/component-text");
const styled_components_1 = require("styled-components");
const info_pane_utils_1 = require("./info-pane.utils");
exports.InfoPaneVersion = function InfoPaneVersion(props) {
    return (React.createElement(exports.StyledInfoPaneVersion, { className: props.className, search: props.search, field: "version" },
        React.createElement(component_text_1.Text, null, props.search)));
};
exports.StyledInfoPaneVersion = styled_components_1.default(search_trigger_1.SearchTrigger) `
  color: ${info_pane_utils_1.versionColor};
  &:link,
  &:visited {
    text-decoration: none;
    color: ${info_pane_utils_1.versionColor};
  }
`;
//# sourceMappingURL=info-pane-version.js.map